import { bulkEditDataInterface } from 'Interfaces/FDPInterfaces/unconstrainedForecastBulkEdit';
import { Dispatch, SetStateAction, useState } from 'react';
import { unconstrainedForecastService } from 'services/fdp/unconstrainedForecastService';

export const useGridSection = ({
  loading: _loading,
  setData,
  setCopyData,
  setIsDataLoading,
}: {
  loading: boolean;
  setData: Dispatch<SetStateAction<[] | bulkEditDataInterface[]>>;
  setCopyData: Dispatch<SetStateAction<[] | bulkEditDataInterface[]>>;
  setIsDataLoading: Dispatch<SetStateAction<boolean>>;
}) => {
  const [notesModalVisibility, setNotesModalVisibility] = useState<boolean>(false);
  const [clickedRowNDC, setClickedRowNDC] = useState<string>('');
  const [savingNDC, setSavingNDC] = useState<string>('');
  const [savingIndex, setSavingIndex] = useState<number>(0);

  const _getInitialData = async () => {
    try {
      setIsDataLoading(true);
      const payload = {
        page_no: 0,
        filters: {
          Ramping: '',
          Concept: '',
          MoleculeAndDosageForm: '',
          StrategyCode: '',
          SellingCategory: '',
          NDC11: '',
          ConceptSort: '',
          SupplierName: '',
          ContractType: '',
        },
      };
      const data = await unconstrainedForecastService.getFilteredData(payload);
      if (data) {
        setData(data);
        setCopyData(data);
      }
    } catch (_error) {
      console.log('Error while getting the data');
    } finally {
      setIsDataLoading(false);
    }
  };

  const getFutureMonthsEdit = () => {
    const arr: { label: string; dateString: string; isExtended: boolean }[] = [];
    const dt = new Date();
    const startMonth = dt.getMonth();
    const startYear = dt.getFullYear();
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i + 1) % 12;
      const year = startYear + Math.floor((startMonth + i + 1) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
        isExtended: i >= 12,
      });
    }

    return arr;
  };
  const forecastingMonthsEdit: { label: string; dateString: string; isExtended: boolean }[] =
    getFutureMonthsEdit();

  const getPriorMonthLabel = (): string => {
    const dt = new Date();
    const monthShortHand = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ];
    return `${monthShortHand[dt.getMonth()]}-${dt.getFullYear()}`;
  };
  const priorMonthLabel = getPriorMonthLabel();

  return {
    forecastingMonthsEdit,
    priorMonthLabel,
    notesModalVisibility,
    clickedRowNDC,
    savingNDC,
    setSavingNDC,
    savingIndex,
    setSavingIndex,
    setClickedRowNDC,
    setNotesModalVisibility,
  };
};
